import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=7a041dca&scoped=true"
import script from "./chatBox.vue?vue&type=script&lang=js"
export * from "./chatBox.vue?vue&type=script&lang=js"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=7a041dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a041dca",
  null
  
)

export default component.exports